




































import {Vue, Component, Watch} from 'vue-property-decorator';
import TweenLite from 'gsap/TweenMax';
import Cover from '@/presentation/slides/Cover.vue';
import List from '@/presentation/slides/List.vue';
import Heading from '@/presentation/slides/Heading.vue';
import Chart from '@/presentation/slides/Chart.vue';
import Comment from '@/presentation/slides/Comment.vue';
import * as api from '@/store/api';
import CompanyName from '@/presentation/slides/CompanyName.vue';
import Table from '@/presentation/slides/Table.vue';
import Agenda from '@/presentation/slides/Agenda.vue';
import Imagex from '@/presentation/slides/Image.vue';
import CompassSlide from '@/presentation/slides/Compass.vue';
import ExtendedCompassSlide from '@/presentation/slides/CompassNew.vue';
import Competitors from '@/presentation/slides/Competitors.vue';
import AnalysisSummary from '@/presentation/slides/AnalysisSummary.vue';
import AnalysisNextStep from '@/presentation/slides/AnalysisNextStep.vue';
import AnalysisInfo from '@/presentation/slides/AnalysisInfo.vue';
import Comments from '@/presentation/Comments.vue';
import PresentationComment from '@/presentation/slides/PresentationComment.vue';
import Schedule from '@/presentation/slides/Schedule.vue';

// tslint:disable:max-line-length
@Component({
  components: {
    Schedule,
    PresentationComment,
    AnalysisInfo,
    AnalysisNextStep,
    AnalysisSummary,
    Competitors, ExtendedCompassSlide,
    CompassSlide, Imagex, Agenda, Table, Cover, List, Heading, Chart, Comment, CompanyName,
    Comments,
  },
})
export default class Presentation extends Vue {
  doc: any | null = null;

  previous: number = 0;
  current: number = 0;
  offset: number = 0;
  window: any = {
    width: 0,
    height: 0,
  };
  options: any = {
    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
  };
  horizontal: boolean = true;

  // showingCommentView: boolean = false;
  // showingCommentEdit: boolean = false;
  commentPaneVisible: boolean = false;

  async mounted() {
    const documentId = this.$route.params.DocumentId;
    this.doc = await api.getDocument(documentId, this.isPrint);
    this.doc.isPrint = this.isPrint;

    if (this.doc.Language !== Vue.prototype.$l) {
      Vue.prototype.$l = this.doc.Language;
      // language.setLanguage(this.doc.Language); // TODO: fix loaded flag (reload issue)
    }
  }

  sectionStyle(i: number) {
    if (this.isPrint) {
      return {};
    }

    return {
      top: ((this.window.height) * i) + 'px',
      transform: 'translateY(' + this.offset + 'px)',
    };
  }

  handleResize() {
    this.horizontal = (window.innerWidth / window.innerHeight) > (16 / 9);
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;
    this.offset = -this.window.height * this.current;

    const el: any = document.body.parentElement;
    if (this.horizontal) {
      el.classList.add('H');
      el.classList.remove('V');
    } else {
      el.classList.add('V');
      el.classList.remove('H');
    }
  }

  handleKey(event: any) {
    if (event.key === 'Tab') {
      // console.log(event.target);
      return;
    }
    if (this.commentPaneVisible) {
      return;
    }
    if (event.key === 'ArrowUp') {
      if (this.current > 0) {
        this.previous = this.current;
        this.current -= 1;
      }
    } else if (event.key === 'ArrowDown') {
      this.previous = this.current;
      if (this.current < (this.sections.length - 1)) {
        this.current += 1;
      }
    }
  }

  created() {
    window.addEventListener('keyup', this.handleKey);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  destroyed() {
    window.removeEventListener('keyup', this.handleKey);
    window.removeEventListener('resize', this.handleResize);

    const el: any = document.body.parentElement;
    el.classList.remove('V');
    el.classList.remove('H');
  }

  @Watch('current', {immediate: true, deep: true})
  onCurrentChanged() {
    if (this.isPrint) {
      return;
    }

    TweenLite.to(this.$data, 0.5, {offset: -this.window.height * this.current});
  }

  get sections() {
    const sections: any[] = [];
    this.addSections(sections, this.doc);
    // for (const s of sections) {
    //   console.log(`${JSON.stringify(s)}`);
    // }
    return sections;
  }

  addSections(sections: any[], item: any) {
    if (!item) {
      return;
    }
    if (item.Kind !== 'section') {
      if (item.Children && !item.Hidden) {
        for (const i of item.Children) {
          const child = this.doc.Items.find((x: any) => x.Id === i);
          this.addSections(sections, child);
        }
      }
    } else {
      if (!item.Hidden) {
        if (item.PrintOnly && !this.isPrint) {
          return;
        }
        sections.push(item);

        // generate variants for interactive charts in print
        if (this.isPrint && item.Type === 'extendedCompass') {
          for (const type of ['operatingMargin', 'growth', 'solidity', 'workingCapitalPct', 'quickRatio', 'interestCoverage', 'riskBuffer', 'returnOnCapital']) {
            const subItem = Object.assign({extendedData: type}, item);
            sections.push(subItem);
          }
        }

        // add comments to print
        const comment = this.getComment(item.Id);
        if (this.isPrint && comment) {
          sections.push({Type: 'presentation_comment', Comment: comment});
        }
      }
    }
  }

  getComment(id: number) {
    if (!this.doc.Comments.Items) {
      return undefined;
    }
    const res = this.doc.Comments.Items.find((x: any) => x.Id === id);
    if (res) {
      return res.Comment;
    }
    return undefined;
  }

  commentChanged(e: any) {
    const res = this.doc.Comments.Items.find((x: any) => x.Id === e.Id);
    if (res) {
      res.Comment = e.Comment;
    } else {
      this.doc.Comments.Items.push(e);
    }
    api.updateDocumentComments(this.doc.Comments);
  }

  scheduleChanged(e: any) {
    const res = this.doc.Items.find((x: any) => x.Id === 61);
    res.Items = e;
    if (this.doc.DocumentId) {
      api.updateDocumentItem(this.doc.DocumentId, {Update: 'Schedule', Id: 61, Items: res.Items} );
    } else {
      api.updateDocumentItem(this.$route.params.DocumentId, {Update: 'Schedule', Id: 61, Items: res.Items} );
    }
  }

  commentPaneChanged(visible: boolean) {
    this.commentPaneVisible = visible;
  }

  get isPrint(): boolean {
    if (!this.$router || !this.$router.currentRoute || !this.$router.currentRoute.name) {
      return false;
    }
    return this.$router.currentRoute.name.endsWith('print');
  }
}
